const Ecommerce = () => import(/* webpackChunkName: "E-commerce" */ '@/views/private/e-commerce/Index.vue')
const DetailEcommerce = () => import(/* webpackChunkName: "E-commerce" */ '@/views/private/e-commerce/detail/Index.vue')
const Category = () => import(/* webpackChunkName: "E-commerce" */ '@/views/private/e-commerce/category/Index.vue')
const Voucher = () => import(/* webpackChunkName: "E-commerce" */ '@/views/private/e-commerce/voucher/Index.vue')
const Transaction = () => import(/* webpackChunkName: "E-commerce" */ '@/views/private/e-commerce/transaction/Index.vue')
const Banner = () => import(/* webpackChunkName: "E-commerce" */ '@/views/private/e-commerce/banner/Index.vue')

const routes = [
  {
    path: "/e-commerce",
    name: "E-commerce",
    component: Ecommerce,
    meta: {
      title: "E-Commerce"
    }
  },
  {
    path: "/e-commerce/detail/:id",
    name: "Detail E-commerce",
    component: DetailEcommerce,
    meta: {
      title: "Detail E-Commerce"
    }
  },
  {
    path: "/e-commerce/category",
    name: "E-commerce category",
    component: Category,
    meta: {
      title: "Kategori E-Commerce"
    }
  },
  {
    path: "/e-commerce/voucher",
    name: "E-commerce voucher",
    component: Voucher,
    meta: {
      title: "Voucher E-Commerce"
    }
  },
  {
    path: "/e-commerce/transaction",
    name: "E-commerce Transaction",
    component: Transaction,
    meta: {
      title: "Transaksi E-Commerce"
    }
  },
  {
    path: "/e-commerce/banner",
    name: "E-commerce Banner",
    component: Banner,
    meta: {
      title: "Banner E-Commerce"
    }
  },
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})